module.exports = __webpack_public_path__ + "img/mail-by-timer.e435c088.png";